import i18n from '@/i18n';
import { countries } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const Countries = () => import('./views/Index.vue');

export default [
  {
    path: 'countries',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.Countries`,
        component: Countries,
        meta: { title: i18n.global.t('countries.countries'), permission: { module: countries.module, key: countries.showAll } },
      },
    ],
  },
];
